import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getCourseExpirationRemaining } from 'utils/courseExpiration'

const ONE_MINUTE_MS = 60 * 1000

export const useCourseExpirationRemainingLabel = (
  accessibleTo: string
): string => {
  const { t } = useTranslation()
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    setNow(Date.now())

    const intervalId = window.setInterval(() => {
      setNow(Date.now())
    }, ONE_MINUTE_MS)

    return () => {
      window.clearInterval(intervalId)
    }
  }, [accessibleTo])

  const remaining = getCourseExpirationRemaining(
    accessibleTo,
    new Date(now)
  )

  switch (remaining.kind) {
    case 'empty':
      return '0'
    case 'expired':
      return t('courses.remaining.expired')
    case 'days':
      return remaining.label
    case 'minutes':
      return t('courses.remaining.minutes', { count: remaining.minutes })
    case 'hoursMinutes': {
      const hoursLabel = t('courses.remaining.hours', {
        count: remaining.hours
      })

      if (remaining.minutes <= 0) {
        return hoursLabel
      }

      const minutesLabel = t('courses.remaining.minutes', {
        count: remaining.minutes
      })

      return `${hoursLabel} ${minutesLabel}`
    }
    default:
      return '0'
  }
}

export default useCourseExpirationRemainingLabel
